import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import List from 'core/modules/Partials/List/List';

import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';

import GiftGuideItem from './components/GiftGuideItem';
import { useGetGiftGuide } from './hooks/useGetGiftGuide';
import { selectGiftGuideConfig } from './selectors';

import './GiftGuide.scss';

function GiftGuide() {
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const { carousel } = useSelector(selectGiftGuideConfig);
  const { giftGuideHeadlinePlacement, giftGuideFeaturedDealsPlacements } = useGetGiftGuide();

  if (isEmpty(giftGuideHeadlinePlacement) || isEmpty(giftGuideFeaturedDealsPlacements)) {
    return null;
  }

  const { clickUrl, assets: { callToActionText, shortSummaryText } } = giftGuideHeadlinePlacement;

  return (
    <div className="mn_giftGuide">
      <ContentWrap mobile tablet l xl>
        <div className="mn_giftGuideInner">
          <SectionTitle title={shortSummaryText} />
          <List options={carousel} shouldUseCarousel={isMobileMQ} hasFillers>
            {giftGuideFeaturedDealsPlacements.map((offer) => (
              <GiftGuideItem {...offer} key={offer.id} />
            ))}
          </List>
          <div className="mn_giftGuideButtonWrap">
            <a className="mn_button mn_giftGuideButton" href={clickUrl}>
              {callToActionText}
            </a>
          </div>
        </div>
      </ContentWrap>
    </div>
  );
}

export default GiftGuide;
